"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (event) {
  event.preventDefault();
  event.stopPropagation();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/lib/view/drag-handle/util/stop-event.js
// module id = 124
// module chunks = 0